import React from 'react'
import PropTypes from 'prop-types'
import { FocusHeader } from '@olxbr/ds-web'
import styled from 'styled-components'
import { WomanAtTheComputer } from '../../atoms/WomanAtTheComputer'
import { HiddenIn } from '../../atoms/HiddenIn'
import { BackButton } from '../../atoms/BackButton/BackButton'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 392px;
`

const ContentWrapper = styled.section`
  max-width: calc(1224px + (var(--spacing-4) * 2));
  padding: var(--spacing-8) var(--spacing-4);
  flex: 1;
`

const ChangeInfoTemplate = ({ title, description, onBackClick, children, hideHeader }) => {
  return (
    <>
      {!hideHeader && <FocusHeader />}
      <div className="flex justify-center">
        <ContentWrapper>
          <div className="flex justify-between">
            <Content>
              {!hideHeader && <BackButton onClick={onBackClick} />}
              <span className="typo-title-large mt-4 mb-2">{title}</span>
              <span className="typo-body-medium mb-4">{description}</span>
              {children}
            </Content>
            <div className="flex items-center">
              <HiddenIn tablet mobile>
                <WomanAtTheComputer />
              </HiddenIn>
            </div>
          </div>
        </ContentWrapper>
      </div>
    </>
  )
}

ChangeInfoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onBackClick: PropTypes.func.isRequired,
  hideHeader: PropTypes.bool,
}

export { ChangeInfoTemplate }
